import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

const TYPE_CONFIG: Record<string, { classes: string }> = {
  OPEN_ORDER: { classes: 'bg-blue-50 text-blue-700 border-blue-200' },
  ADDRESS_MANAGEMENT: { classes: 'bg-orange-50 text-orange-700 border-orange-200' },
  SUPPORT_REQUEST: { classes: 'bg-purple-50 text-purple-700 border-purple-200' },
  BUILD: { classes: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};

interface TypeBadgeProps {
  type: string;
  className?: string;
}

export function TypeBadge({ type, className }: TypeBadgeProps) {
  const { t } = useTranslation('common');
  const config = TYPE_CONFIG[type] || {
    classes: 'bg-slate-50 text-slate-600 border-slate-200',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider',
        config.classes,
        className
      )}
    >
      {t(`ticketTypeShort.${type}`, { defaultValue: type })}
    </span>
  );
}
